/* eslint-disable no-unused-vars */
// import core & vendor packages below
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

// import components below
import Layout from 'components/Layout';
import PageHeader from './components/PageHeader';
import SideBar from 'components/ACLComponents/SideBar';
import ChargesContainer from './components/ChargesContainer';

// main component
const Charges = () => {
  return (
    <Layout pageTitle='Charges'>
      <PageHeader />

      <Row className='mt-4'>
        <Col sm={9}>
          <ChargesContainer />
        </Col>
        <Col sm={3}>
          <SideBar />
        </Col>
      </Row>
    </Layout>
  );
};

export default Charges;
